export const LOG_LEVEL_OFF = "off"

export const LOG_LEVEL_DEBUG = "debug"

export const LOG_LEVEL_INFO = "info"

export const LOG_LEVEL_WARN = "warn"

export const LOG_LEVEL_ERROR = "error"
